// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"f381ea47","238":"d444a488","773":"00b444f0"}[chunkId] + ".chunk.css";
};